'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataBox = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sectionMargin: state.templateData.inter_section_margin,
    show_timeline: state.company.show_timeline,
    analysis_mode_on: state.templateData.analysis_mode_on
  };
}, {}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DataBox, _Component);

  function DataBox(props) {
    (0, _classCallCheck3.default)(this, DataBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DataBox.__proto__ || (0, _getPrototypeOf2.default)(DataBox)).call(this, props));

    var _this$props = _this.props,
        type = _this$props.type,
        placeholder = _this$props.placeholder,
        defaultValue = _this$props.defaultValue;

    _this.state = {
      data_id: _this.props.data_id,
      data_parent: _this.props.data_parent,
      group: _this.props.group,
      section_analysis_visible: false
    };
    return _this;
  }

  (0, _createClass3.default)(DataBox, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.analysis_mode_on != this.props.analysis_mode_on) {
        this.setState({ section_analysis_visible: this.props.analysis_mode_on });
      }
    }
    // componentWillReceiveProps(nextProps) {
    //   this.setState({data_id: nextProps.data_id});
    // }

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          sectionMargin = _props.sectionMargin,
          dataSectionStyleClass = _props.dataSectionStyleClass,
          dataAspectRatio = _props.dataAspectRatio,
          dataBlockClass = _props.dataBlockClass;
      var _props2 = this.props,
          data_id = _props2.data_id,
          data_parent = _props2.data_parent,
          group = _props2.group; // eslint-disable-line no-shadow

      var dataStyleClassObject = this.props.dataStyleClass !== '' ? JSON.parse(this.props.dataStyleClass.replace(/'/g, '"')) : false;
      // console.log(dataStyleClassObject ? dataStyleClassObject['heading'].slice(1,).join(' ') : false);
      // console.log(this.props.dataOrder, data_parent)
      var order = this.props.dataOrder.replace(/\s/g, '').split(',');
      var style = { paddingBottom: sectionMargin + 'px', paddingTop: sectionMargin + 'px' };
      var ProfessionalBlock = order.map(function (data_type, index) {
        return _react2.default.createElement(
          'div',
          { className: 'section-' + index + ' ' + dataSectionStyleClass },
          data_type.indexOf(':') > -1 ? data_type.split(':').map(function (internal_data_type, internal_index) {
            return _react2.default.createElement(
              'div',
              { key: internal_index, className: internal_data_type + ' ' + (dataStyleClassObject ? dataStyleClassObject[internal_data_type] ? dataStyleClassObject[internal_data_type].slice(1).join(' ') : '' : '') },
              _react2.default.createElement('div', { className: internal_data_type + '-before' }),
              _react2.default.createElement(
                'div',
                { className: internal_data_type + '-after' },
                _react2.default.createElement(_components.SingleLine, {
                  placeholder: 'Enter a ' + internal_data_type,
                  data_id: data_id,
                  data_parent: data_parent,
                  group: group,
                  data_type: internal_data_type,
                  textAreaColorClass: dataStyleClassObject ? dataStyleClassObject[internal_data_type] ? dataStyleClassObject[internal_data_type][0] : '' : ''
                })
              )
            );
          }) : _react2.default.createElement(
            'div',
            { key: index, className: data_type + ' ' + (dataStyleClassObject ? dataStyleClassObject[data_type] ? dataStyleClassObject[data_type].slice(1).join(' ') : '' : '') },
            _react2.default.createElement('div', { className: data_type + '-before' }),
            _react2.default.createElement(
              'div',
              { className: data_type + '-after' },
              _react2.default.createElement(_components.SingleLine, {
                placeholder: 'Enter a ' + data_type,
                data_id: data_id,
                data_parent: data_parent,
                group: group,
                data_type: data_type,
                textAreaColorClass: dataStyleClassObject ? dataStyleClassObject[data_type] ? dataStyleClassObject[data_type][0] : '' : ''
              })
            )
          )
        );
      });

      return _react2.default.createElement(
        'div',
        { className: 'block ' + dataBlockClass },
        this.state.section_analysis_visible && _react2.default.createElement(_components.SubSectionAnalysis, {
          data_id: data_id,
          data_parent: data_parent
        }),
        _react2.default.createElement(
          'div',
          { className: 'single-wrapper' },
          ProfessionalBlock
        ),
        data_parent === 'CH' && _react2.default.createElement(_components.Chart, { data_parent: data_parent, dataAspectRatio: dataAspectRatio, data_id: data_id, group: group, data_type: 'chart_data' }),
        this.props.show_timeline && data_parent === 'TI' && _react2.default.createElement(_components.TimelineChart, { dataSectionStyleClass: dataSectionStyleClass, data_parent: data_parent, data_id: data_id, group: group, data_type: 'chart_data' }),
        _react2.default.createElement(
          'div',
          { className: 'multi-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'description ' + dataSectionStyleClass },
            _react2.default.createElement(_components.MultiLine, {
              placeholder: 'Enter description',
              data_id: data_id,
              data_parent: data_parent,
              group: group,
              data_type: 'description',
              sectionMargin: sectionMargin
            })
          )
        )
      );
    }
  }]);
  return DataBox;
}(_react.Component), _class2.propTypes = {
  data_id: _react.PropTypes.number,
  data_parent: _react.PropTypes.string
}, _temp)) || _class);
exports.default = DataBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/DataBox/DataBox.js
// module id = 1758
// module chunks = 0